import { axios } from './axios';

export const syncFulfillmentWithAftership = async ({
  fulfillmentId,
}: {
  fulfillmentId: string;
}) => {
  return await axios.patch(`fulfillments/${fulfillmentId}/sync_fulfillment_with_aftership`);
};
